"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dh = void 0;
const dh = (dataHook, match = '=') => `[data-hook${match}"${dataHook}"]`;
exports.dh = dh;
//# sourceMappingURL=dh.js.map